<template>
  <div class="steps" :class="toc">
    <button
      class="step-circle"
      @click.prevent="emitStepClicked"
      :aria-label="ariaLabelStepNumber"
    >
      <div class="step-number" v-if="visited && !active && !toc">
        <img :src="checkSrc" alt="check mark" />
      </div>
      <div class="step-number" v-else>
        {{ stepNumber }}
      </div>
    </button>
    <div
      v-if="hideNotVisited"
      class="step-page"
      role="button"
      @click="emitStepClicked"
      :aria-label="stepTitle"
    >
      <div class="step-page-title">{{ stepTitle }}</div>
    </div>
    <div v-else class="step-page" role="button" @click="emitStepClicked">
      <div class="step-page-title">{{ stepTitle }}</div>
      <div
        class="not-visited"
        v-if="!visited && !active && !toc"
        aria-describedby="Not Visited"
      >
        Not Visited
      </div>
    </div>
    <div class="step-vertical-line" v-if="vertical && !toc"></div>
    <div class="step-line" v-else-if="!toc"></div>
  </div>
</template>

<script>
import check from "../../images/check-blue.svg";

export default {
  name: "VStepperStep",
  props: {
    stepNumber: { type: Number, required: true },
    visited: { type: Boolean, default: false },
    stepTitle: { type: String, required: true },
    active: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    toc: { type: Boolean, default: false },
    hideNotVisited: { type: Boolean, default: false },
  },
  data() {
    return {
      checkSrc: check,
    };
  },
  computed: {
    visitColor() {
      if (this.active && !this.toc) {
        return "var(--blue-900)";
      }
      if (this.visited && !this.toc) {
        return "var(--blue-100)";
      }
      return "var(--gray-200)";
    },
    stepNumberColor() {
      if (this.active && !this.toc) {
        return "white";
      }
      if (!this.visited) {
        return "black";
      }
      return "";
    },
    ariaLabelStepNumber() {
      return `Go to Step ${this.stepNumber} for ${this.stepTitle} page`;
    },
  },
  methods: {
    emitStepClicked() {
      this.$emit("clicked", this.stepNumber);
    },
  },
};
</script>

<style scoped>
.steps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.steps.toc {
  margin-bottom: 1rem;
}
.step-circle {
  all: unset;
}
.step-circle,
.step-page {
  cursor: pointer;
}
.step-number {
  display: flex;
  justify-content: center;
  align-items: center;
  font-variant-numeric: tabular-nums;
  border-radius: 100%;
  height: 2rem;
  width: 2rem;
  background-color: v-bind(visitColor);
  color: v-bind(stepNumberColor);
}
.step-check {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.step-page {
  margin: 0 0.5rem;
}
.step-page .not-visited {
  font-size: var(--font-size-50);
}

.step-page-title {
  font-size: var(--font-size-100);
}

.step-line {
  width: 2.5rem;
  border-bottom: 1px solid var(--gray-400);
  margin-right: 0.5rem;
}
.steps:last-child > .step-line:last-child,
.steps:last-child > .step-vertical-line {
  display: none;
}
.step-vertical-line {
  border-left: 1px solid var(--gray-400);
  height: 1rem;
  margin: 0.5rem 0;
}
</style>
